import React, { useEffect, useMemo, useState } from 'react';
import GlobalWrapper from '../../../components/Wrapper/GlobalWrapper';
import { Stack } from '@mui/material';
import GlobalSelectFieldWithoutFormikNew from '../../../components/mui/GlobalSelectFieldWithoutFormikNew';
import GlobalTable from '../../../components/CustomTableWithPagination/GlobalTable';
import { expiringAdmissionHeader } from './utils/expiringAdmissionHeader';
import { useDispatch } from 'react-redux';
import { isSameUserType } from '../../../utils/helperFunction';
import { getCROlistUnderProject } from '../../../redux/features/CRDslice';
import { getAllProjects } from '../../../redux/features/courseSlice';
import { getExpiringAdmissionTable } from '../../../redux/features/crdMigrationSlice';
import { MONTHS } from '../../../utils/constants/daysConst';
import { croTypeNames } from '../../../utils/employeeTypes';
import { useSelector } from 'react-redux';

export default function ExpiringAdmission() {
  const dispatch = useDispatch();

  // Redux State-------------------------------------------------------------
  const allProjects = useSelector((state) => state.course.projects);
  const crosunderproject = useSelector((state) => state.crd.crosunderproject);
  const courseLoading = useSelector((state) => state.course.loading);

  const loading = useSelector((state) => state.crdMigration.expiringAdmissionTable.loading);
  const tableData = useSelector((state) => state.crdMigration.expiringAdmissionTable.data);
  const meta = useSelector((state) => state.crdMigration.expiringAdmissionTable.meta);
  //--------------------------------------------------------

  // react state
  const [project, setProject] = useState({ id: '', name: '' });
  const [cro, setCRO] = useState({ id: '', name: '' });
  const [month, setMonth] = useState({ id: '', name: '' });
  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 50,
    search: '',
  });
  // checking is CRO or not
  const isCro = useMemo(() => {
    const profile = JSON.parse(localStorage.getItem('cred')).profile;
    return isSameUserType({ roleArray: croTypeNames, role: profile?.role });
  }, []);

  // Fetch  Projects All roles ---------------------------------------------
  useEffect(() => {
    dispatch(getAllProjects());
  }, [dispatch]);

  //--------------------------------------------

  // -----------fetch cro list (pm,Crm only) ------
  useEffect(() => {
    if (!isCro) {
      dispatch(getCROlistUnderProject(project?.id ?? -1));
      setCRO({ id: '', name: '' });
    }
  }, [project, dispatch, isCro]);
  // ---------------------------------------------------------

  //---------- DispatchParams ---------------------------------
  const dispatchParams = useMemo(
    () => ({
      project: project?.id ?? null,
      cro: isCro ? null : (cro?.id ?? null),
      month: month?.id ?? null,
      page: tableState?.page,
      limit: tableState?.pageSize,
      search: tableState?.search,
    }),
    [project, month, cro, tableState, isCro],
  );

  //---------* =-=-=-==-=--=-=-=-=- *---------------------------

  //-------------- Table Fetch ------------------------------
  useEffect(() => {
    dispatch(getExpiringAdmissionTable(dispatchParams));
  }, [dispatchParams, dispatch]);
  //-------------* Table Fetch *-----------------------------

  return (
    <GlobalWrapper title={'Expiring Admissions'}>
      <Stack gap={2}>
        <Stack direction={{ xs: 'column', sm: 'row' }} gap={1}>
          <GlobalSelectFieldWithoutFormikNew
            label={'Month'}
            data={MONTHS}
            keys={{
              itemId: 'id',
              itemValue: 'name',
            }}
            selectedDetails={month}
            setChange={setMonth}
            sx={{
              width: { xs: '100%', sm: 200 },
            }}
          />
          <GlobalSelectFieldWithoutFormikNew
            label={'Project'}
            data={[{ id: -1, name: 'All' }, ...allProjects]}
            keys={{
              itemId: 'id',
              itemValue: 'name',
            }}
            selectedDetails={project}
            setChange={setProject}
            sx={{
              width: { xs: '100%', sm: 200 },
            }}
            disabled={courseLoading}
          />
          {!isCro && (
            <GlobalSelectFieldWithoutFormikNew
              label={'CRO'}
              data={[{ id: -1, name: 'All' }, ...crosunderproject]}
              keys={{
                itemId: 'id',
                itemValue: 'name',
              }}
              selectedDetails={cro}
              setChange={setCRO}
              sx={{ width: { xs: '100%', sm: 200 } }}
            />
          )}

          {/* cro list for pm crd  */}
        </Stack>
        <GlobalTable
          headers={expiringAdmissionHeader}
          tableState={tableState}
          setTableState={setTableState}
          loading={loading}
          rows={[]}
        />
      </Stack>
    </GlobalWrapper>
  );
}
